import type { LocaleObject } from "@nuxtjs/i18n";

export const LOCALE_STORAGE_KEY = "advisor/locale";

export default defineNuxtPlugin(({ $i18n }) => {
  const availableLocales = $i18n.locales;

  function isSupportedLocale(code: string | null): code is "en" | "sv" {
    return code === "en" || code === "sv";
  }

  const activeLocale = computed<"en" | "sv">(() => {
    const current = $i18n.locale.value as string | null;
    if (isSupportedLocale(current)) {
      return current;
    }

    const fallbackLocale = availableLocales.value.find((locale: LocaleObject) =>
      isSupportedLocale(locale.code as string | null)
    );
    if (fallbackLocale) {
      return fallbackLocale.code as "en" | "sv";
    }

    return "en";
  });

  function setAppLocale(payload: "en" | "sv") {
    if (payload) {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem(LOCALE_STORAGE_KEY, payload);
      }
      $i18n.setLocale(payload);
    }
  }

  function getAppLocale(_activeLocale: "en" | "sv" = activeLocale.value) {
    return availableLocales.value.find((locale: LocaleObject) => locale.code === _activeLocale);
  }

  return {
    provide: {
      availableLocales,
      activeLocale,
      setAppLocale,
      getAppLocale,
    },
  };
});
